import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { observer } from "mobx-react";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import LoaderSpinner from "@components-shared/LoaderSpinner";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { useFixBody } from "@state/hooks/shared";

export default observer(function CancelBetSlipPopUp() {
	const { t } = useTranslation();

	const store = useContext(MyBetsStoreContext);

	useFixBody(true, store?.betCancelStore?.isCancelPopUpOpen);

	if (!store || !store.betCancelStore) {
		return null;
	}

	if (store.betCancelStore.loader?.isLoadingProcess) {
		return <LoaderSpinner isLoading />;
	}

	if (!store.betCancelStore.isCancelPopUpOpen) {
		return null;
	}

	if (store.betCancelStore.betCancelMessage != null) {
		return (
			<div className="popup">
				<div className="popup__card">
					<div className="popup__header">
						{t<string>("mybets:BET_CANCEL.INFO_TITLE")}
					</div>
					<div className="popup__body">
						<InfoMessageComponent
							type="note"
							message={
								store.betCancelStore
									.betCancelMessage as string
							}
						/>
					</div>
					<div className="popup__footer">
						<button
							className="popup__btn btn btn--med btn--primary--inverted"
							type="button"
							onClick={
								store.betCancelStore.onExitBetCancel
							}
						>
							{t<string>("COMMON.CLOSE")}
						</button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header">
					{t<string>("mybets:CASHOUT.BET_SLIP_NUMBER", {
						0:
							store.betCancelStore.betToCancel?.betSlipNumber ||
							"",
					})}
				</div>
				<div className="popup__body">
					{t<string>("mybets:CANCEL_SLIP_TEXT")}
				</div>
				<div className="popup__footer">
					<button
						className="popup__btn btn btn--med btn--primary--inverted"
						type="button"
						onClick={store.betCancelStore.onExitBetCancel}
					>
						{t<string>("BET_SLIP.NO")}
					</button>
					<button
						className="popup__btn btn btn--med btn--primary"
						type="button"
						onClick={store.betCancelStore.onBetCancelConfirm}
					>
						{t<string>("COMMON.YES")}
					</button>
				</div>
			</div>
		</div>
	);
});
